import React from "react";

export default function(){
  return (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
    <rect width="256" height="256" fill="none" />
    <line x1="216" y1="128" x2="40" y2="128" fill="none" stroke="currentColor" strokeLinecap="round"
          strokeLinejoin="round" strokeWidth="16" />
    <polyline points="112 56 40 128 112 200" fill="none" stroke="currentColor" strokeLinecap="round"
              strokeLinejoin="round" strokeWidth="16" />
  </svg>
  );
}